import React, { FC, useState } from 'react';
import { Tabs } from 'antd';
import { Navigate } from 'react-router-dom';
import { ERoute } from 'common/const/route.enum';
import { AUTH_REDIRECT_TIMEOUT_MS } from 'common/config';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { AuthCardLogo } from 'entities/Auth/components/AuthCardLogo';
import { AuthCardFooter } from 'entities/Auth/components/AuthCardFooter';
import { LoginSuccessCard } from 'entities/Auth/components/Login/LoginSuccessCard';
import { LoginByCredentials } from 'entities/Auth/components/Login/LoginByCredentials';
import { LoginByOtp } from 'entities/Auth/components/Login/LoginByOtp';
import { IAuthLoginPayload } from 'entities/Auth/Auth.models';
import { getUserRole } from 'entities/User/User.helper';
import { addAuth, selectAuth, selectAuthError, selectIsAuthLoading, setAuthError } from 'entities/Auth/Auth.slice';

export const LoginPage: FC = () => {
  const dispatch = useAppDispatch();
  // auth
  const auth = useAppSelector(selectAuth);
  const isAuthLoading = useAppSelector(selectIsAuthLoading);
  const authError = useAppSelector(selectAuthError);

  const [showSuccessCard, setShowSuccessCard] = useState<boolean>(false);
  const [canBeRedirected, setCanBeRedirected] = useState<boolean>(true);

  const { isSuperAdmin } = getUserRole(auth?.access.roles);

  const onSubmit = async (value: IAuthLoginPayload) => {
    setCanBeRedirected(false);
    dispatch(setAuthError(null));

    await dispatch(
      addAuth({
        ...value,
        onSuccess: () => {
          setShowSuccessCard(true);
          setTimeout(() => setCanBeRedirected(true), AUTH_REDIRECT_TIMEOUT_MS);
        },
      }),
    );
  };

  const onTabChange = () => {
    dispatch(setAuthError(null));
  };

  if (auth && canBeRedirected) {
    if (auth.access.isSelfRegistered && !auth.access.selfRegistrationCompletedAt) {
      return <Navigate to={ERoute.SelfRegistration} replace />;
    }

    return isSuperAdmin ? <Navigate to={ERoute.AccountList} replace /> : <Navigate to={ERoute.Profile} replace />;
  }

  if (showSuccessCard) {
    return <LoginSuccessCard firstName={auth?.access.firstName} patronymic={auth?.access.patronymic} />;
  }

  const tabItems = [
    {
      key: 'credentials',
      label: 'Логин и пароль',
      children: <LoginByCredentials loading={isAuthLoading} error={authError} onSubmit={onSubmit} />,
    },
    {
      key: 'otp',
      label: 'Войти по коду',
      children: <LoginByOtp />,
    },
  ];

  return (
    <div className="redesign auth-card">
      <AuthCardLogo />

      <div className="auth-card__content">
        <div style={{ height: 560 }}>
          <Tabs
            className="auth-card-tabs"
            tabBarStyle={{ marginBottom: 40 }}
            centered
            items={tabItems}
            defaultActiveKey="credentials"
            onChange={onTabChange}
            destroyInactiveTabPane
          />
        </div>
      </div>

      <AuthCardFooter content="СПРАУТ. Система управления закупками." />
    </div>
  );
};
